import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { ScrollSync, ScrollSyncPane } from 'react-scroll-sync';
import PropTypes from 'prop-types';

import WithCompare from './compare-container';
import Button from '../../ui/components/button';
import CompareTable from './compare-table';
import { Grid, Column } from '../../ui/components/grid';
import CompareBox from './compare-box';
import CompareBoxDetail from './compare-box-detail';
import Link from '../../ui/components/link';
import Icon from '../../ui/components/icon';

import './compare-view.less';

function CompareView(props) {
    const { compareProducts, history, toggleCompareProduct, compareResultsV2: compareResults, compareSlots } = props;

    const [isFirstHalf, setIsFirstHalf] = useState(true);
    const productsView = useRef(null);

    const monitorScroll = () => {
        const { scrollWidth, scrollLeft } = productsView.current;
        setIsFirstHalf(scrollLeft / scrollWidth > 0.4);
    };

    useEffect(() => {
        const scrollView = document.getElementById('compare-view-horizontal-scroll');
        scrollView.addEventListener('scroll', monitorScroll);
        return () => scrollView.removeEventListener('scroll', monitorScroll);
    }, []);

    useEffect(() => {
        props.getProductCompare();
    }, [compareProducts.length]);

    if (compareProducts.length === 1) {
        history.goBack();
    }

    const emptyItems = Array.from(Array(compareSlots - compareProducts.length).keys());

    return (
        <ScrollSync vertical={false} proportional={false}>
            <div className="compare-view">
                <div className="top-bar">
                    <span className="back" onClick={() => history.goBack()}>
                        <Icon name="left_small" />
                        BACK
                    </span>
                    <span className="count">
                        {compareProducts.length}
                        /4
                    </span>
                    <Button text="close" color="white" action="remove" size="small" onClick={() => history.goBack()} />
                </div>
                <ScrollSyncPane>
                    <div
                        id="compare-view-horizontal-scroll"
                        className="horizontal-scroll fixed"
                        data-scrollsync
                        ref={productsView}
                    >
                        <Grid className="compare">
                            <Column desktop={2} hide={['small', 'xs', 'xxs']} />
                            {[...compareProducts]
                                .slice()
                                .reverse()
                                .map((product, i) => (
                                    <Column key={i} desktop={2} small={2} mobile={2}>
                                        <CompareBox
                                            product={product}
                                            toggleCompareProduct={products => toggleCompareProduct(products, true)}
                                        />
                                    </Column>
                                ))}
                            {emptyItems.map(k => (
                                <Column key={k} className="compare-box" desktop={2} small={2} mobile={2} />
                            ))}
                            <Column className="actions" desktop={2} hide={['small', 'xs', 'xxs']}>
                                <span className="count">
                                    {compareProducts.length}
                                    /4
                                </span>
                                <Button
                                    text="close"
                                    action="remove"
                                    color="white"
                                    size="small"
                                    onClick={() => history.goBack()}
                                />
                            </Column>
                        </Grid>
                    </div>
                </ScrollSyncPane>
                <div className="bottom-bar fixed">
                    <span className={`bar${isFirstHalf ? '' : ' active'}`} />
                    <span className={`bar${isFirstHalf ? ' active' : ''}`} />
                </div>
                <ScrollSyncPane>
                    <div className="horizontal-scroll wrapper" data-scrollsync>
                        <div className="content">
                            <Grid className="product-cards">
                                <Column desktop={2} hide={['small', 'xs', 'xxs']} />
                                {[...compareProducts]
                                    .slice()
                                    .reverse()
                                    .map((product, i) => (
                                        <Column key={i} desktop={2} small={2} mobile={2}>
                                            <CompareBoxDetail
                                                product={product}
                                                toggleCompareProduct={products => toggleCompareProduct(products, true)}
                                            />
                                        </Column>
                                    ))}
                                {emptyItems.map(k => (
                                    <Column
                                        key={k}
                                        className={`compare-box ${k === 0 ? 'add-new' : 'empty'}`}
                                        desktop={2}
                                        small={2}
                                        mobile={2}
                                    >
                                        <span>
                                            {k === 0 && (
                                                <Link button onClick={() => history.goBack()}>
                                                    add new similar
                                                </Link>
                                            )}
                                        </span>
                                    </Column>
                                ))}
                                <Column desktop={2} hide={['small', 'xs', 'xxs']} />
                            </Grid>
                            {/* SAMPLE TEMPLATE until we get data */}
                            <div className="container">
                                {compareResults && (
                                    <CompareTable compareProducts={compareProducts} compareResults={compareResults} />
                                )}
                            </div>
                            {/* <CompareModal {...props} /> */}
                        </div>
                    </div>
                </ScrollSyncPane>
            </div>
        </ScrollSync>
    );
}

CompareView.defaultProps = {
    compareSlots: 4,
    compareResultsV2: null,
};

CompareView.propTypes = {
    /** list of products to compare */
    compareProducts: PropTypes.arrayOf(PropTypes.object).isRequired,
    /** add/remove products from compare list */
    toggleCompareProduct: PropTypes.func.isRequired,
    /** compare attribute details of products list */
    compareResultsV2: PropTypes.arrayOf(PropTypes.object),
    /** available slots to display for product comparisons */
    compareSlots: PropTypes.number,
};

export default WithCompare(withRouter(CompareView));
